import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { PrismSnackbarService } from '@shure/prism-angular-components';

@Injectable({ providedIn: 'root' })
export class EscapeButtonService {
	private readonly _escapeButtonPressed$ = new Subject<KeyboardEvent>();

	/**
	 * escapeButtonPressed$ emits if the escape key has been pressed and the event is not already being handled.
	 * This way, subscribers can have the opportunity to handle those events.
	 * For example, the escape key will blur an open mat-select field by default. In that case, we don't emit.
	 */
	public readonly escapeButtonPressed$ = this._escapeButtonPressed$.asObservable();

	private readonly snackbar = inject(PrismSnackbarService);

	public onEscapeButtonKeydown(event: KeyboardEvent): void {
		if (this.snackbar.getOpenSnackbar()) {
			this.snackbar.getOpenSnackbar()?.dismiss();
			return;
		}
		if (this.isEventTargetEscapable(event)) {
			const element = <HTMLElement>event.target;
			element.blur();
			return;
		}
		this._escapeButtonPressed$.next(event);
	}

	private isEventTargetEscapable(event: KeyboardEvent): boolean {
		const element = <Element>event.target;
		const escapableTags = ['input', 'mat-select'];
		return (
			(escapableTags.includes(element.tagName.toLowerCase()) || element.className.includes('ag-menu-option')) &&
			element.getAttribute('escapable') !== 'false'
		);
	}
}
